<template>
  <main class="activation-page">
    <section class="activation-card" aria-labelledby="activation-title">
      <h1 id="activation-title">{{ activated ? '账号已激活' : '激活 DCMP 试用账号' }}</h1>
      <p v-if="loading">正在核验激活链接…</p>
      <Alert v-if="error" :title="error" type="error" :closable="false" show-icon />
      <div v-if="activated" class="activation-success">
        <p>组织名称：<strong>{{ activated.companyName }}</strong></p>
        <p>登录邮箱：{{ activated.email }}</p>
        <p>试用期已开始，请使用刚设置的密码登录。</p>
        <a :href="activated.loginUrl" rel="noreferrer" class="login-link">前往 DCMP 登录</a>
      </div>
      <Form v-else-if="preview" ref="form" :model="form" :rules="rules" label-position="top" @submit.native.prevent="activate">
        <p>组织名称：<strong>{{ preview.companyName }}</strong></p>
        <p>登录邮箱：{{ preview.email }}</p>
        <p class="help">激活后可试用 {{ preview.trialDays }} 天。密码须为8–32位，包含大写字母、小写字母和数字，不能包含空格。</p>
        <FormItem label="设置密码" prop="password">
          <Input v-model="form.password" type="password" show-password autocomplete="new-password" :maxlength="32" />
        </FormItem>
        <FormItem label="确认密码" prop="confirmPassword">
          <Input v-model="form.confirmPassword" type="password" show-password autocomplete="new-password" :maxlength="32" />
        </FormItem>
        <Button type="primary" native-type="submit" :loading="submitting" :disabled="submitting">设置密码并激活</Button>
      </Form>
      <p v-if="!loading && !preview && !activated" class="help">链接过期或已被替换时，请联系运营人员重发激活邀请。已经激活的账号可直接登录。</p>
    </section>
  </main>
</template>
<script>
import { Form, FormItem, Input, Button, Alert } from 'element-ui';
import { trialRequest } from '@/utils/trialApi';
export default {
  components: { Form, FormItem, Input, Button, Alert },
  data() {
    return {
      token: '', preview: null, activated: null, loading: true, submitting: false, error: '',
      form: { password: '', confirmPassword: '' },
      rules: {
        password: [{ validator: (rule, value, done) => done(
          /^[\x21-\x7e]{8,32}$/.test(value) && /[A-Z]/.test(value) && /[a-z]/.test(value) && /[0-9]/.test(value)
            ? undefined : new Error('密码须为8–32位，包含大小写字母和数字，不能包含空格')), trigger: 'blur' }],
        confirmPassword: [{ validator: (rule, value, done) => done(
          value && value === this.form.password ? undefined : new Error('两次输入的密码不一致')), trigger: 'blur' }],
      },
    };
  },
  async created() {
    this.token = new URLSearchParams(window.location.hash.slice(1)).get('token') || '';
    window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
    try {
      if (!/^[A-Za-z0-9_-]{43}$/.test(this.token)) throw new Error('激活链接无效，请从邮件中的完整链接进入。');
      this.preview = await trialRequest('/preview', { token: this.token });
    } catch (error) { this.error = error.message; }
    finally { this.loading = false; }
  },
  beforeDestroy() { this.token = ''; this.form.password = ''; this.form.confirmPassword = ''; },
  methods: {
    activate() {
      if (this.submitting) return;
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.submitting = true; this.error = '';
        try {
          this.activated = await trialRequest('/activate', { token: this.token, ...this.form });
          this.token = ''; this.form.password = ''; this.form.confirmPassword = '';
        } catch (error) { this.error = error.message; }
        finally { this.submitting = false; }
      });
    },
  },
};
</script>
<style scoped>
.activation-page{min-height:70vh;padding:64px 24px;background:#f2f7fc;font-size:16px;color:#24394b}
.activation-card{max-width:560px;background:#fff;border-radius:12px;padding:36px;margin:auto;line-height:1.8}
.activation-card h1{font-size:26px;margin:0 0 24px}.activation-card .el-alert{margin-bottom:20px}
.help{font-size:14px;color:#66788a}.activation-card .el-button,.login-link{width:100%;background:#005c85;border-color:#005c85;color:white;font-size:16px}
.login-link{display:block;text-align:center;padding:10px;margin-top:24px;border-radius:4px}
</style>
